<div class="notFound">
    <img src = '../../../assets/images/notFound.png'>
</div>